<template>
  <div
    class="d-flex flex-column gr-6"
    :class="{ 'px-2 py-6': isMobile }"
  >
    <a
      :href="reverseFull({ name: 'ethical_commission' })"
      class="d-inline-flex align-center gc-2 primary--text text-decoration-none align-self-start"
      text
    >
      <span class="ui-icon-arrow-back" />
      <span class="text-body-1">{{ t('Назад', options) }}</span>
    </a>

    <main class="d-flex flex-column gr-6">
      <div
        v-for="(ethicalCommissionMeeting, index) in ethicalCommissionMeetings"
        :key="index"
      >
        <a
          v-if="isStaff && !isMobile"
          target="_blank"
          rel="noopener noreferrer"
          class="adminka mx-0 mb-2 pa-1 d-inline-block text-body-2"
          :href="reverseFull({ name: 'admin:info_ethicalcommissionmeeting_change', args: [ethicalCommissionMeeting.id] })"
        >
          {{ t('Править заседание', options) }}
        </a>
        <div class="d-flex align-center">
          <div class="text-h6 text--text mb-2">
            {{ t('Заседание', options) }} {{ ethicalCommissionMeeting.meeting_number }}
          </div>
          <CorePRG
            v-if="ethicalCommissionMeeting.protocol && isMobile"
            target="_blank"
            rel="noopener noreferrer"
            :button-attrs="{ class: 'primary--text link-decoration-none' }"
            class="ml-auto"
            :url="ethicalCommissionMeeting.protocol"
          >
            {{ t('Протокол', options) }}
          </CorePRG>
        </div>

        <div class="text-body-2 text-secondary--text d-flex align-center gc-7 mb-4">
          <span>{{ ethicalCommissionMeeting.meeting_date }}</span>
          <span :class="{ 'ml-auto': isMobile }">{{ t('Количество присутствующих:', options) }} {{ ethicalCommissionMeeting.number_of_present }}</span>
          <CorePRG
            v-if="ethicalCommissionMeeting.protocol && !isMobile"
            target="_blank"
            rel="noopener noreferrer"
            :button-attrs="{ class: 'primary--text link-decoration-none' }"
            class="ml-auto"
            :url="ethicalCommissionMeeting.protocol"
          >
            {{ t('Протокол', options) }}
          </CorePRG>
        </div>

        <div
          class="d-flex flex-column gr-6 elevation-1 rounded-sm"
          :class="isMobile ? 'pa-4' : 'pa-6'"
        >
          <template v-for="(meetingCase, meetingCaseIndex) in ethicalCommissionMeeting.cases.all">
            <v-divider
              v-if="meetingCaseIndex !== 0"
              :key="`divider-${meetingCaseIndex}`"
            />
            <MeetingCard
              :key="`meeting-case-${meetingCase.id}`"
              :is-staff="isStaff"
              :meeting-case="meetingCase"
            />
          </template>
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup>
import { useContextStore, useURLStore } from 'src/store'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import type {
  ContextStore,
  EthicalCommissionMeeting,
} from 'src/components/pages/info/ethical-commission/meetings/types'
import MeetingCard from 'src/components/pages/info/ethical-commission/meetings/components/MainContent/components/MeetingCard/MeetingCaseCard.vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  isStaff: boolean
  ethicalCommissionMeetings: EthicalCommissionMeeting[]
}>()

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()

const isMobile = context.flavour === 'mobile'
</script>
